import { DownOutlined } from '@ant-design/icons';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { Loader } from 'zComponents/atoms';
import { EditSiteModal } from 'zComponents/molecules';
import { Button, Card, Col, Dropdown, Flex, Row, Typography } from 'zui/Antd';

const { Title } = Typography;

const IndividualSiteSummary = ({ siteInfo }) => {
	const history = useLocation();
	const currentPath = history.pathname;

	const [loadings, setLoading] = useState(true);
	const [data, setData] = useState([]);
	const [sites, setSites] = useState([]);

	const { data: sitesData, loading: sitesDataPending } = useSelector((state) => state.Sites);

	useEffect(() => {
		setLoading(true);
		setData(siteInfo);
		if (!sitesDataPending) {
			setSites(sitesData);
		}
		setLoading(false);
	}, [siteInfo, sitesData, sitesDataPending]);

	return loadings ? (
		<Row gutter={0} justify='space-around'>
			<Col lg={24} md={24} sm={24} xs={24}>
				<Loader />
			</Col>
		</Row>
	) : (
		<Card>
			<Row gutter={[16, 16]}>
				<Col
					lg={{ span: 12, order: 1 }}
					md={{ span: 24, order: 1 }}
					sm={{ span: 24, order: 1 }}
					xs={{ span: 24, order: 1 }}
				>
					<Title style={{ margin: 0 }} level={4}>
						{data.name}
					</Title>
				</Col>
				<Col
					lg={{ span: 24, order: 3 }}
					md={{ span: 24, order: 2 }}
					sm={{ span: 24, order: 2 }}
					xs={{ span: 24, order: 2 }}
				>
					<div style={{ width: '100%', height: '100%' }}>
						{/* <HybridMap data={{ url: data.mapUrl || 'n/a', ...data, markers: [] }} mapType={'Site'} /> */}
					</div>
				</Col>
				<Col
					lg={{ span: 12, order: 2 }}
					md={{ span: 24, order: 3 }}
					sm={{ span: 24, order: 3 }}
					xs={{ span: 24, order: 3 }}
				>
					<Flex gap={8} justify='flex-end'>
						{sites.length > 0 ? (
							<Dropdown
								menu={{
									items: sitesData.map((site) => {
										return {
											label: site.name,
											onClick: () => {
												history.push({
													pathname: currentPath,
													state: { siteID: site.siteID }
												});
											}
										};
									})
								}}
								trigger={['click']}
							>
								<Button>
									Sites <DownOutlined />
								</Button>
							</Dropdown>
						) : null}
						<EditSiteModal data={data} />
					</Flex>
				</Col>
			</Row>
		</Card>
	);
};

export default IndividualSiteSummary;
